<template>
  <v-dialog v-model="isDialogVisible" max-width="650">
    <v-card class="prompts-dialog">
      <v-btn class="button-close ma-4" icon @click="close()">
        <v-icon>mdi-close</v-icon>
      </v-btn>
      <v-card-title>
        <h4 class="mt-1">Готовые запросы</h4>
      </v-card-title>
      <v-card-text>
        <div class="d-flex mt-5">
          <v-text-field v-model="strFilter" prepend-inner-icon="mdi-magnify" label="Найти" placeholder="" outlined dense class="mr-3">
            <template v-slot:append>
              <v-btn text icon style="margin-top:-5px" @click="strFilter=''"><v-icon>mdi-close</v-icon></v-btn>
            </template>
          </v-text-field>
          <v-btn icon color="_primary" outlined :disabled="tab===0" class="mr-3" @click="onAddPromptUser()">
            <v-icon>mdi-plus</v-icon>
          </v-btn>
          <v-btn icon color="_primary" outlined :disabled="tab===0 || !selectedPromptUserId" class="mr-3" @click="showPromptUserEditDialog=true">
            <v-icon>mdi-pencil-outline</v-icon>
          </v-btn>
          <v-btn icon color="error" outlined :disabled="tab===0 || !selectedPromptUserId" @click="showAskDelDialog=true" :loading="loading.delPromptUser">
            <v-icon>mdi-delete-outline</v-icon>
          </v-btn>
        </div>
        <v-tabs v-model="tab"   class="mb-3">
          <v-tab no-caps :value="0">Готовые запросы</v-tab>
          <v-tab :value="1">Мои запросы</v-tab>
        </v-tabs>
        <!-- {{selectedPromptStdId}} {{selectedPromptUserId}} -->
        <v-tabs-items v-model="tab" >
          <v-tab-item :value="0" key="0">
            <v-sheet height="300" class="overflow-y-auto">
              <v-radio-group :value="selectedPromptStdId" column class="mt-0" v-if="filteredStdItems.length" @change="setSelectedPromptStdId">
                <v-radio v-for="item in filteredStdItems" :key="item.id" :value="item.id" class="ml-2 my-1 d-flex align-start" hide-details>
                  <template v-slot:label>
                    <div class="clickable-text mt-1" @click="setSelectedPromptStdId(item.id)" v-html="prepareText(item.title)" />
                  </template>
                </v-radio>
              </v-radio-group>
              <div v-else class="w-100 text-center mt-3">
                {{ strFilter ? 'Ничего не найдено' : 'Список пуст' }}
              </div>
            </v-sheet>
          </v-tab-item>
          <v-tab-item :value="1" >
            <v-sheet height="300" class="overflow-y-auto">
              <v-radio-group :value="selectedPromptUserId" column class="mt-0" v-if="filteredUserItems.length" @change="setSelectedPromptUserId">
                <v-radio v-for="item in filteredUserItems" :key="item.id" :value="item.id" class="ml-2 my-1 d-flex align-start" hide-details>
                  <template v-slot:label>
                    <div class="clickable-text mt-1" @click="setSelectedPromptUserId(item.id)" v-html="prepareText(item.title)" />
                  </template>
                </v-radio>
              </v-radio-group>
              <div v-else class="w-100 text-center mt-3">
                {{ strFilter ? 'Ничего не найдено' : 'Список пуст' }}
              </div>
            </v-sheet>
          </v-tab-item>
        </v-tabs-items>
        <div class="d-flex justify-end mt-2 mb-3" >
          <v-btn @click="close()" color="primary" outlined class="mr-3">Отменить</v-btn>
          <v-btn @click="showPrompt()" color="primary" :disabled="tab ? !selectedPromptUserId : !selectedPromptStdId">Просмотреть</v-btn>
        </div>
      </v-card-text>
    </v-card>
    <AskDialog v-model="showAskDelDialog" @ok="delPromptUser(selectedPromptUserId)"
      title="Удаление промпта"
      text="Вы уверены, что хотите удалить выбранный промпт из раздела «Мои запросы»? Действие не может быть отменено."
    />
    <PromptUserEditDialog v-model="showPromptUserEditDialog" />
    <ShowPromptDialog v-model="showUsePromptDialog" @ok="usePrompt" :title="curPrompt.title" :content="curPrompt.content" />

  </v-dialog>
</template>

<script>
/* eslint-disable */
import { mapActions, mapGetters, mapMutations } from 'vuex';
import { cloneDeep } from 'lodash';
import AskDialog from "@/components/ui/AskDialog"
import { escapeHtml } from '@/common/util';
import PromptUserEditDialog from "./PromptUserEditDialog.vue"
import ShowPromptDialog from "./ShowPromptDialog.vue"

export default {
  name: 'PromptsDialog',
  components: {
    AskDialog, PromptUserEditDialog, ShowPromptDialog
  },
  model: {
    prop: 'value',
    event: 'input',
  },
  props: {
    value: Boolean,
  },
  data: () => ({
    tab: 0,
    strFilter: "",
    showAskDelDialog: false,
    showPromptUserEditDialog: false,
    showUsePromptDialog: false,
    curPrompt: { content: '' },
  }),
  watch: {
    async value(val) {
      if (val) {
        // await this.loadCustomers();
      }
    },
  },
  computed: {
    ...mapGetters({
      user: 'auth/user',
      promptsStd: 'ai/prompts/promptsStd',
      promptsUser: 'ai/prompts/promptsUser',
      loading: 'ai/prompts/loading',
      selectedPromptStdId: 'ai/prompts/selectedPromptStdId',
      selectedPromptUserId: 'ai/prompts/selectedPromptUserId',
      getSelectedPromptUser: 'ai/prompts/getSelectedPromptUser',
      getSelectedPromptStd: 'ai/prompts/getSelectedPromptStd',
    }),
    isDialogVisible: {
      get() {
        return this.value;
      },
      set(value) {
        if (!value) {
          this.close()
        }
      },
    },
    filteredUserItems() {
      return this.strFilter ? this.promptsUser.filter(el=> el.content.toLowerCase().includes(this.strFilter.toLowerCase())) : this.promptsUser
    },
    filteredStdItems() {
      return this.strFilter ? this.promptsStd.filter(el=> el.title.toLowerCase().includes(this.strFilter.toLowerCase())) : this.promptsStd
    },
  },
  methods: {
    ...mapActions({
      delPromptUser: 'ai/prompts/delPromptUser',
      loadPromptUser: 'ai/prompts/loadPromptUser',
      loadPromptStd: 'ai/prompts/loadPromptStd',
    }),
    ...mapMutations({
      setSelectedPromptUserId: 'ai/prompts/setSelectedPromptUserId',
      setSelectedPromptStdId: 'ai/prompts/setSelectedPromptStdId',
    }),
    onAddPromptUser() {
      this.setSelectedPromptUserId(0)
      this.showPromptUserEditDialog = true
    },
    prepareText(text) {
      return text ? escapeHtml(text).replace(new RegExp('\r?\n','g'), '<br />') : '';
    },
    close(ret) {
      this.$emit('input', ret);
    },
    async showPrompt(ret) {
      let prompt = { content: '' }
      if (this.tab) {
        prompt = await this.loadPromptUser(this.selectedPromptUserId)
      } else {
        prompt = await this.loadPromptStd(this.selectedPromptStdId)
      }
      if (prompt) {
        this.curPrompt = prompt
        this.showUsePromptDialog = true
      }
    },
    usePrompt() {
      this.$emit('ok', this.curPrompt.content);
      this.close()
    },
  }
}
</script>

<style>
.prompts-dialog .v-tab {
  text-transform: capitalize !important;
  font-weight: bold;
  letter-spacing: 0;
}
</style>
